import { isFunction, isPlainObject, toLower, toPairs } from "lodash-es";
import { absoluteUrl } from "src/app/support/navigation";
import { InvoiceMasterMode } from "src/app/modules/bootstrap/pms-ui/modules/organization/invoice/invoice-master/invoice-master-type";
import { HealthRecord } from "src/app/backend/models/health-record";

export const routes = generateRoutes(
  {
    configuration: {
      manage_users: {
        groups: {
          master: () => "",
          id: (id: string) => `/${id}`,
          edit: (id: string) => `/${id}/edit`
        },
        members: {
          master: () => "",
          id: (id: string) => `/${id}`,
          edit: (id: string) => `/${id}/edit`
        },
        roles: {
          id: (id: string) => `/${id}`,
          id_edit: (id: string) => `/${id}/edit`,
          master: () => ""
        },
        shifts: {
          master: () => ""
        }
      },
      letterhead: {
        master: () => ``,
        id: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      }
    },
    organization: {
      changelog: {
        master: () => ``
      },
      help_center: {
        master: () => ``
      },
      late_paying_customers: {
        master: () => ``
      },
      campaign_templates: {
        master: () => "",
        edit: (id: string) => `/${id}/edit`
      },
      remunerations: {
        master: () => ""
      },
      reminders: {
        master: () => ""
      },
      analytics: {
        sales: {
          master: () => ""
        },
        incomes: {
          master: () => ""
        },
        customers: {
          master: () => ""
        },
        patients: {
          master: () => ""
        },
        tickets: {
          master: () => ""
        },
        reminders: {
          master: () => ""
        }
      },
      kpi: {
        master: () => ``
      },
      dashboard: {
        master: () => ``
      },
      calendar: {
        list: () => ``
      },
      check_out: {
        id: (cartId: string) => `/${cartId}`
      },
      invoices: {
        paper: (status: "draft" | "emitted") => `/paper/${status}`,
        advance: (status: "draft" | "emitted") => `/advance/${status}`,
        eletronic: (status: "draft" | "emitted") => `/eletronic/${status}`,
        exchange: (status: "draft" | "emitted") => `/exchange/${status}`,
        mode_list: (mode: InvoiceMasterMode, status: "draft" | "emitted") =>
          `/${mode}/${status}`,
        mode_detail_id: (mode: InvoiceMasterMode, invoiceId: string) =>
          `/${mode}/detail/${invoiceId}`,
        mode_detail_id_edit: (mode: InvoiceMasterMode, invoiceId: string) =>
          `/${mode}/detail/${invoiceId}/edit`,
        create: () => `/create`
      },
      quotes: {
        list: () => ``,
        id: (quoteId: string) => `/${quoteId}`,
        id_edit: (quoteId: string) => `/${quoteId}/edit`
      },
      customers_registry: {
        list: () => ``,
        id: (customerId: string) => `/${customerId}`,
        id_edit: (customerId: string) => `/${customerId}/edit`,
        document_create: (customerId: string, documentId: string) =>
          `/${customerId}/documents/${documentId}`,
        document_edit: ({
          customerId,
          attachmentId
        }: {
          customerId: string;
          attachmentId: string;
        }) => `/${customerId}/documents/edit/${attachmentId}`,
        document_clone: ({
          customerId,
          attachmentId
        }: {
          customerId: string;
          attachmentId: string;
        }) => `/${customerId}/documents/clone/${attachmentId}`
      },
      patients_registry: {
        list: () => ``,
        id: (patientId: string) => `/${patientId}`,
        id_edit: (patientId: string) => `/${patientId}/edit`,
        documents_create: (
          patientId: string,
          documentId: string,
          relativeId: string
        ) => `/${patientId}/documents/${documentId}/relatives/${relativeId}`,
        documents_clone: ({
          patientId,
          attachmentId
        }: {
          patientId: string;
          attachmentId: string;
        }) => `/${patientId}/documents/clone/${attachmentId}`,
        documents_edit: ({
          patientId,
          attachmentId
        }: {
          patientId: string;
          attachmentId: string;
        }) => `/${patientId}/documents/edit/${attachmentId}`,
        compare_laboratory_exams: (
          patientId: string,
          healthRecords: HealthRecord<any>[]
        ) =>
          `/${patientId}/laboratory/compare/${healthRecords
            .map((x) => x.id)
            .join(",")}`,
        work_orders_laboratory_create_request: (
          patientId: string,
          workOrderId: string
        ) =>
          `/${patientId}/work-orders/${workOrderId}/laboratory/create-request`,
        work_orders_diagnostic_create_request: (
          patientId: string,
          workOrderId: string
        ) =>
          `/${patientId}/work-orders/${workOrderId}/diagnostic/create-request`,
        diagnostic_viewer: (patientId: string, studyId: string) =>
          `/${patientId}/diagnostic-viewer/${studyId}`
      },
      rate_table: {
        medical_services_id: ({
          rateTableId,
          medicalServiceId
        }: {
          rateTableId: string;
          medicalServiceId: string;
        }) => `/${rateTableId}/medical-services/${medicalServiceId}`,
        medical_services_id_edit: ({
          rateTableId,
          medicalServiceId
        }: {
          rateTableId: string;
          medicalServiceId: string;
        }) => `/${rateTableId}/medical-services/${medicalServiceId}/edit`,
        list: () => ``,
        id: (rateTableId: string) => `/${rateTableId}`,
        id_edit: (rateTableId: string) => `/${rateTableId}/edit`
      },
      visit: {
        id: (healthRecordId: string) => `/${healthRecordId}`
      },
      vaccine: {
        id: (healthRecordId: string) => `/${healthRecordId}`
      },
      laboratory: {
        id: (healthRecordId: string) => `/${healthRecordId}`
      },
      diagnostic: {
        id: (healthRecordId: string) => `/${healthRecordId}`
      },
      documents: {
        master: () => ``,
        id: (documentId: string) => `/${documentId}`,
        edit: (documentId: string) => `/${documentId}/edit`
      },
      reminders_templates: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      appointment_templates: {
        list: () => ``,
        id: (appointmentTemplateId: string) => `/${appointmentTemplateId}`,
        id_edit: (appointmentTemplateId: string) =>
          `/${appointmentTemplateId}/edit`
      },
      soap_templates: {
        list: () => ``,
        id: (soapTemplateId: string) => `/${soapTemplateId}`,
        id_edit: (soapTemplateId: string) => `/${soapTemplateId}/edit`
      },
      work_orders: {
        list: () => ``,
        id: (workOrderId: string) => `/${workOrderId}`,
        id_edit: (workOrderId: string) => `/${workOrderId}/edit`
      },
      sendings: {
        fiscal_profiles: {
          sendings: (
            fiscalProfileId: string,
            realm: "tessera-sanitaria" | "fatturazione-elettronica"
          ) => `/${fiscalProfileId}/${realm}/sendings`,
          sendings_detail: (
            fiscalProfileId: string,
            realm: "tessera-sanitaria" | "fatturazione-elettronica",
            sendingId: string
          ) => `/${fiscalProfileId}/${realm}/sendings/${sendingId}`,
          invoices_to_send: (
            fiscalProfileId: string,
            realm: "tessera-sanitaria" | "fatturazione-elettronica"
          ) => `/${fiscalProfileId}/${realm}/invoices-to-send`
        }
      },
      passive: {
        fiscal_profiles: {
          passive: (fiscalProfileId: string) => `/${fiscalProfileId}/passive`,
          passive_detail: (fiscalProfileId: string, invoiceId: string) =>
            `/${fiscalProfileId}/passive/${invoiceId}`
        }
      },
      quote_templates: {
        list: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      drugs: {
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`
      },
      physicians: {
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`
      },
      products: {
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`,
        master: () => `/`
      },
      fiscal_profiles: {
        list: () => ``,
        id: (fiscalProfileId: string) => `/${fiscalProfileId}`,
        id_edit: (fiscalProfileId: string) => `/${fiscalProfileId}/edit`
      },
      payment_methods: {
        list: () => ``,
        id: (paymentMethodId: string) => `/${paymentMethodId}`,
        id_edit: (paymentMethodId: string) => `/${paymentMethodId}/edit`
      },
      bank_accounts: {
        list: () => ``,
        id: (bankAccountId: string) => `/${bankAccountId}`,
        id_edit: (bankAccountId: string) => `/${bankAccountId}/edit`
      },
      export: {
        list: () => ``
      },
      import: {
        list: () => ``
      },
      tasks: {
        master: () => ``,
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`
      },
      check_in: {
        new_visit: () => `/visit`,
        new_recovery: () => "/recovery"
      },
      board: {
        master: () => ``
      },
      prescriptions: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      recoveries: {
        all: () => "/all",
        in_progress: () => "/in-progress",
        detail: (id: string) => `/${id}`,
        document: (id: string, documentId: string) =>
          `/${id}/documents/${documentId}`
      },
      vaccines: {
        list: () => ``,
        id: (vaccineId: string) => `/${vaccineId}`,
        id_edit: (vaccineId: string) => `/${vaccineId}/edit`
      },
      cost_centers: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      revenue_centers: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      tax_rates: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      unit_measures: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      species: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      appointment_reasons: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`,
        id_edit: (uuid: string) => `/${uuid}/edit`
      },
      support: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`
      },
      live_interactions: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`
      },
      comunications: {
        campaigns: {
          list: () => ``,
          id: (campaignId: string) => `/${campaignId}`,
          id_edit: (campaignId: string) => `/${campaignId}/edit`
        },
        segmentations: {
          list: () => ``,
          id: (segmentationId: string) => `/${segmentationId}`,
          id_edit: (segmentationId: string) => `/${segmentationId}/edit`
        }
      },
      surveys: {
        list: () => ``,
        id: (id: string) => `/${id}`
      },
      alarms: {
        master: () => ``,
        id: (id: string) => `/${id}`
      },
      filters: {
        master: () => ``,
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`
      },
      integrations: {
        master: () => ``,
        id: (id: string) => `/${id}`,
        installation_id: (id: string, installationId: string) =>
          `/${id}/installations/${installationId}`
      }
    },
    warehouse: {
      goods: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      storage: {
        id: (id: string) => `/${id}`,
        good_id: (id: string, goodId: string) => `/${id}/good/${goodId}`
      },
      storage_registry: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      business_unit_registry: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      supplier_registry: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      },
      delivery: {
        master: () => ``,
        detail: (id: string) => `/${id}`
      },
      movements: {
        list: () => ``,
        id: (id: string) => `/${id}`
      },
      sellings: {
        master: () => ``
      }
    },
    account: {
      tenant: {
        master: () => ``,
        detail: (id: string) => `/${id}`,
        edit: (id: string) => `/${id}/edit`
      }
    },
    profile: {
      detail: () => ``,
      edit: () => `/edit`
    },
    company: {
      wards: {
        master: () => ``,
        id_edit: (id: string) => `/${id}/edit`
      }
    },
    lite: {
      dashboard: () => ``,
      scheduler: {
        master: () => ``,
        appointment: (id: string) => `/${id}`
      }
    }
  },
  {},
  ""
);

export const routes_rocket = generateRoutes(
  {
    help_center: {
      master: () => ``
    },
    reporting: {
      master: () => ``,
      id: (id: string) => `/${id}`,
      reported: () => `/reported`,
      report: (id: string, instanceUuid: string) => `/${id}/${instanceUuid}`,
      viewer: (studyId: string, studyUuid: string) =>
        `/viewer/${studyId}/${studyUuid}`
    },
    requests: {
      list: () => `/`,
      id: (id: string) => `/${id}`,
      create: () => "/create"
    },
    studies: {
      master: () => `/master`,
      archived: () => `/archived`,
      id: (id: string) => `/${id}`,
      id_reporting: (id: string, instanceUuid: string) =>
        `/${id}/report/${instanceUuid}`
    },
    customers: {
      master: () => ``,
      id: (customerId: string) => `/${customerId}`,
      id_edit: (customerId: string) => `/${customerId}/edit`
    },
    profile: {
      id: (memberId: string) => `/${memberId}`,
      id_edit: (memberId: string) => `/${memberId}/edit`
    },
    patients: {
      master: () => ``,
      id: (patientId: string) => `/${patientId}`,
      id_edit: (patientId: string) => `/${patientId}/edit`
    },
    configuration: {
      general: {
        list: () => ``,
        registry_heading_id_edit: (registryUuid: string) =>
          `/registry-heading/${registryUuid}/edit`,
        template_email_id_edit: (templateUuid: string) =>
          `/template-email/${templateUuid}/edit`
      },
      devices: {
        list: () => ``,
        id: (id: string) => `/${id}`,
        id_edit: (id: string) => `/${id}/edit`
      },
      archives: {
        list: () => ``,
        id: (uuid: string) => `/${uuid}`
      },
      template_report: {
        master: () => ``,
        id_edit: (id: string) => `/${id}/edit`
      },
      letterhead: {
        master: () => ``,
        edit: (id: string) => `/${id}/edit`
      },
      tag: {
        master: () => ``,
        edit: (id: string) => `/${id}/edit`
      },
      exports: {
        master: () => ``
      },
      backups: {
        master: () => ``
      },
      physicians: {
        master: () => ``,
        edit: (id: string) => `/${id}/edit`,
        detail: (id: string) => `/${id}`
      },
      manage_users: {
        groups: {
          master: () => ``,
          id: (id: string) => `/${id}`,
          id_edit: (id: string) => `/${id}/edit`
        },
        members: {
          master: () => "",
          id: (id: string) => `/${id}`,
          edit: (id: string) => `/${id}/edit`
        },
        roles: {
          id: (id: string) => `/${id}`,
          id_edit: (id: string) => `/${id}/edit`,
          master: () => ""
        }
      }
    },
    alarms: {
      master: () => ``,
      detail: (id: string) => `/${id}`
    },
    analytics: {
      studies: {
        master: () => ""
      }
    },
    tenant: {
      id: (id: string) => `/${id}`,
      edit: (id: string) => `/${id}/edit`
    }
  },
  {},
  ""
);

export const routes_admin = generateRoutes(
  {
    domains: {
      list: () => ``,
      id: (id: string) => `/${id}`,
      id_edit: (id: string) => `/${id}/edit`
    },
    accounts: {
      list: () => ``,
      id: (id: string) => `/${id}`,
      id_edit: (id: string) => `/${id}/edit`
    },
    tenants: {
      list: () => ``,
      id: (id: string) => `/${id}`,
      id_alarm_id: (id: string, alarmId: string) => `/${id}/alarms/${alarmId}`,
      id_edit: (id: string) => `/${id}/edit`
    },
    services: {
      list: () => ``,
      id: (id: string) => `/${id}`,
      id_edit: (id: string) => `/${id}/edit`
    },
    orders: {
      list: () => ``,
      id: (id: string) => `/${id}`
    },
    exports: {
      list: () => ``
    }
  },
  {},
  ""
);

export const routes_platform = generateRoutes(
  {
    catalog: {
      master: () => ``
    },
    orders: {
      master: () => ``
    },
    inbox: {
      master: () => ``
    },
    members: {
      master: () => ``,
      id: (id: string) => `/${id}`,
      id_edit: (id: string) => `/${id}/edit`
    }
  },
  {},
  ""
);

export const routes_drop_page = generateRoutes(
  {
    master: () => ``
  },
  {},
  ""
);

export const routes_dazerolab = generateRoutes(
  {
    bots: {
      master: () => ``,
      id: (id: string) => `/${id}`,
      job: (id: string, jobId: string) => `/${id}/jobs/${jobId}`
    }
  },
  {},
  ""
);

export function generateRoutes<T extends Record<string, any>>(
  data: T,
  structure: any,
  path: string
): T {
  toPairs(data).forEach(([key, value]) => {
    switch (true) {
      case isPlainObject(value): {
        let prefix = `${path}/${toLower(key)}`;

        structure[key] = generateRoutes(value, {}, prefix);
        break;
      }
      case isFunction(value): {
        structure[key] = (...args: any[]) =>
          absoluteUrl(`${path}${value.apply(null, args)}`).replace(/_/gi, "-");
        break;
      }
    }
  });

  return structure;
}
